const INTEREST_OPTIONS = [
  "Technical",
  "Marketing",
  "Documentation",
  "Business",
  "Operations",
];

export let stepThree = [
  {
    type: "ConditionalRadioButton",
    fieldLabel: "Choose your first Interest",
    stateName: "firstNonTechnicalSecondaryCommittee",
    options: INTEREST_OPTIONS,
    // Picking a first interest that is already the second one clears the
    // second, so the two can never end up identical.
    clearOnConflict: ["secondNonTechnicalSecondaryCommittee"],
    revalidates: ["secondNonTechnicalSecondaryCommittee"],
  },
  {
    type: "ConditionalRadioButton",
    fieldLabel: "Choose your second Interest.",
    stateName: "secondNonTechnicalSecondaryCommittee",
    options: INTEREST_OPTIONS,
    mustDifferFrom: "firstNonTechnicalSecondaryCommittee",
    mustDifferErrMsg: "Your second interest must be different from your first",
    mustDifferHint: "(already your first interest)",
  },
];
